import React from 'react';
import './employee_image_style.scss';
import EmployeeImagePlaceholder from '../../../../../assets/img/spacetags/employeeimageplaceholder.jpg';

class EmployeeImage extends React.Component {
  render() {
    return(
      <div className={'employee-image'}>
         {
          (this.props.image !== "" && this.props.image !== null && this.props.image !== undefined)?
          <img src={ this.props.image } alt="" width={250}/>:<img src={ EmployeeImagePlaceholder } alt="" width={250}/>
        }
      </div>
    )
  }
}

export default EmployeeImage;
